// Add your custom JS here.
document.addEventListener('DOMContentLoaded', () => {
    /**
     * Scrolls to an element with header offset
     */
    const scrollto = (el) => {
        const header = select('#wrapper-navbar');
        let offset = header.offsetHeight;
        if (!header.classList.contains('header-scrolled')) {
            offset -= 20;
        }

        const elementPos = select(el).offsetTop;
        window.scrollTo({
            top: elementPos - offset,
            behavior: 'smooth'
        });
    };

    // Cache selectors outside of the event listener for better performance.
    const selectHeader = document.querySelector('#wrapper-navbar');
    const annoucement = document.querySelector('.cta-block');
    let annoucementHeight = annoucement ? annoucement.offsetHeight : 0;
    let lastScrollY = window.scrollY;
    let ticking = false;

    const updateHeaderPosition = () => {
        if (lastScrollY > 150) {
            selectHeader.classList.add('header-scrolled');
            if (annoucement) {
                selectHeader.style.top = `-${annoucementHeight}px`;
            }
        } else {
            selectHeader.classList.remove('header-scrolled');
            if (annoucement) {
                selectHeader.style.top = "0px";
            }
        }
        ticking = false; // Reset the ticking
    };

    const onScroll = () => {
        lastScrollY = window.scrollY;
        // Only run the updateHeaderPosition function in the next animation frame if it's not already scheduled.
        if (!ticking) {
            window.requestAnimationFrame(updateHeaderPosition);
            ticking = true; // Prevent further RAF call being scheduled
        }
    };

// Listen for the scroll event
    window.addEventListener('scroll', onScroll);

// Initial setup
    updateHeaderPosition();

    //target class for video player
    var lity = document.querySelector('.lity-video');
    if (typeof(lity) != 'undefined' && lity != null)
    {
        var ytLink = lity.id;

        var org_html = lity.innerHTML;
        lity.innerHTML = "<a data-lity href='"+ytLink+"'>" + org_html + "</a>";
    }

    adjustHeroPadding();

    window.addEventListener('resize', adjustHeroPadding);

});

function adjustHeroPadding() {
    // Check if .cta-block exists
    var mainHeader = document.querySelector('#wrapper-navbar');
    // Get the height of .cta-block
    var mainHeaderHeight = mainHeader.offsetHeight + 'px';

    // Add padding-top to .video-bg .wp-block-cover__inner-container
    var videoBgContainer = document.querySelector('.video-bg .wp-block-cover__inner-container');
    if (videoBgContainer) {
        videoBgContainer.style.paddingTop = mainHeaderHeight;
    }

    // Add padding-top to .hero .wp-block-cover__inner-container
    var heroContainer = document.querySelector('.hero .wp-block-cover__inner-container');
    if (heroContainer) {
        heroContainer.style.paddingTop = mainHeaderHeight;
    }
}